import { render, staticRenderFns } from "./CardContent.vue?vue&type=template&id=8d8d15a4&scoped=true"
import script from "./CardContent.vue?vue&type=script&lang=js"
export * from "./CardContent.vue?vue&type=script&lang=js"
import style0 from "./CardContent.vue?vue&type=style&index=0&id=8d8d15a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8d15a4",
  null
  
)

export default component.exports